//////////////////////////////////////////////////////////////////////////////
//
//  Tenant API
//
//  작성자: MediInStep Team
//  생성일: 2025-01-XX
//
//  설명: 테넌트 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 테넌트 관련 API
 */
const TenantAPI: ApiGroup = {
  pagedList: {
    title: "테넌트 목록 조회",
    url: "/Tenant/PagedList",
    method: "POST",
    paramz: {},
  },
  list: {
    title: "전체 테넌트 목록 조회",
    url: "/Tenant/List",
    method: "GET",
    paramz: {},
  },
  getById: {
    title: "테넌트 상세 조회",
    url: "/Tenant/{id}",
    method: "GET",
    paramz: {},
    pathParams: ["id"],
  },
  create: {
    title: "테넌트 등록",
    url: "/Tenant",
    method: "POST",
    paramz: {},
  },
  update: {
    title: "테넌트 수정",
    url: "/Tenant/{id}",
    method: "PUT",
    paramz: {},
    pathParams: ["id"],
  },
  delete: {
    title: "테넌트 삭제",
    url: "/Tenant/{id}",
    method: "DELETE",
    paramz: {},
    pathParams: ["id"],
  },
}

export default TenantAPI
